import React from "react";
import styled from "@emotion/styled";

import EditLocationIcon from "@mui/icons-material/EditLocation";
import Button from "components/Button";

import ParkkiTheme from "themes/ParkkiTheme";

// @ts-ignore
const StyledButton = styled(Button)<{ disabled?: boolean }>`
  background-color: ${(props) =>
    props.disabled ? ParkkiTheme.colors.disabledGrey : "default"};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  .MuiButton-iconSizeLarge > *:first-of-type {
    font-size: 26px;
  }
  .MuiButton-startIcon {
    margin-right: 0px;
    margin-left: 0px;
  }
`;

const ToggledButton = styled(StyledButton)`
  background-color: ${ParkkiTheme.colors.disabledGrey};
`;

type Props = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  toggled: boolean;
  disabled?: boolean;
};

function SelectedLayersSectionButton({
  disabled,
  onClick,
  toggled,
}: Props): JSX.Element {
  const ButtonComponent = !toggled ? ToggledButton : StyledButton;

  return (
    <ButtonComponent
      disabled={disabled}
      size="large"
      color="primary"
      fullWidth={false}
      startIcon={<EditLocationIcon />}
      onClick={onClick}
    />
  );
}

export default SelectedLayersSectionButton;
